import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../../components/header_logged'
import Footer from '../../../../../components/footer'
import Head from '../../../../../components/head';
import Carta from '../../../../../components/auth/institucional/cartaservico/listar/cart'


function VisualizarCartaServicosScreen() {

    return (
        <Fragment>
            <Head titulo="Visualizando Carta de Serviços ao Cidadão" />
            <HeaderLogged />
            <Container>
               <Carta />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default VisualizarCartaServicosScreen;